export interface BasemapCategory {
  label: string;
  defaultItem: string;
  items: Array<string>;
}

export interface LegendProps {
  label: string;
  imageData?: string;
  contentType?: string;
  image?: Blob;
}

export interface MapServerLegend {
  layerId: number;
  legend: LegendProps[] | null;
}

export interface MapServerLegends {
  layers: MapServerLegend[];
}

export const MapTypeCategory = new Map<string, string>([
  ['topicmaps.geo.ag.ch', 'ag_topic_type'],
  ['wms.geo.ag.ch', 'ag_layer_type'],
  ['wms.geo.admin.ch', 'ch_layer_type'],
]);

export interface MapLayerSetting {
  id: number;
  name: string;
  subLayerIds: Array<number>;
  parentLayerId: number;
  minScale: number;
  maxScale: number;
  isGroupLayer: boolean;
  isEnabled: boolean;
  isVisible: boolean;
  isRoot: boolean;
  isExpanded: boolean;
  order: number;
}
export interface SubLayerProps {
  id: number;
  isEnabled: boolean;
  isExpanded: boolean;
}
